import { browserSupportsWebAuthn, startRegistration, startAuthentication } from "@simplewebauthn/browser";

import { userEmailSelector } from "../reducers/AuthReducer";

export const CREATE_BIOMETRIC_SUCCESS = "CREATE_BIOMETRIC_SUCCESS";
export const VERIFY_BIOMETRIC_SUCCESS = "VERIFY_BIOMETRIC_SUCCESS";
export const BIOMETRIC_NOT_SUPPORTED = "BIOMETRIC_NOT_SUPPORTED";
export const BIOMETRIC_CREATE_ID = "BIOMETRIC_CREATE_KEY";

function bufferToBase64URL(buffer) {
  const base64 = btoa(String.fromCharCode(...buffer));
  return base64
    .replace(/\+/g, "-")
    .replace(/\//g, "_")
    .replace(/=+$/, "");
}

async function generateChallenge() {
  // Using access token currently doesn't provide any security currently. It can be changed to any text and fingerprint will still work.
  // Just adding incase we need to compare challenge stored while registration is same as what is provided during verification
  const accessToken = "dummy-access-token"; // TODO: dummy is fone until challenge is generated on the server side
  return bufferToBase64URL(new TextEncoder().encode(accessToken));
}

function createBiometric() {
  return async (_, getState) => {
    const challenge = await generateChallenge();
    const email = userEmailSelector(getState());

    const options = {
      challenge: challenge,
      rp: {
        name: "Kubera",
        id: window.location.hostname // important!
      },
      user: {
        id: bufferToBase64URL(new TextEncoder().encode(email)), // stable unique ID
        name: email,
        displayName: email
      },
      pubKeyCredParams: [
        { type: "public-key", alg: -7 },
        { type: "public-key", alg: -8 },
        { type: "public-key", alg: -257 }
      ],
      authenticatorSelection: {
        authenticatorAttachment: "platform",
        userVerification: "required",
        residentKey: "discouraged"
      },
      timeout: 60000,
      attestation: "none"
    };

    const credential = await startRegistration({ optionsJSON: options });

    if (credential) {
      return {
        type: CREATE_BIOMETRIC_SUCCESS,
        payload: {
          credentialId: credential.rawId,
          publicKey: credential.response.attestationObject,
          signCount: credential.response.clientDataJSON
        }
      };
    }

    return null;
  };
}

export function verifyBiometric(credentialId) {
  return async dispatch => {
    const isBiometricAvailable = browserSupportsWebAuthn();
    if (!isBiometricAvailable) return { type: BIOMETRIC_NOT_SUPPORTED };

    if (!credentialId) {
      return await dispatch(createBiometric());
    } else {
      const challenge = await generateChallenge();

      const option = {
        challenge: challenge,
        allowCredentials: [
          {
            id: credentialId,
            type: "public-key"
          }
        ],
        rpId: window.location.hostname,
        authenticatorSelection: {
          authenticatorAttachment: "platform",
          userVerification: "required",
          residentKey: "discouraged"
        }
      };

      const assertion = await startAuthentication({ optionsJSON: option });

      if (assertion) {
        return {
          type: VERIFY_BIOMETRIC_SUCCESS,
          payload: {
            assertionId: assertion.rawId,
            publicKey: assertion.response.authenticatorData,
            signCount: assertion.response.clientDataJSON
          }
        };
      }
    }

    return null;
  };
}
